import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { Tooltip } from "components/Tooltips/Tooltip";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useIsOverflown } from "hooks/useIsOverflown";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    badge: {
      height: "24px",
      backgroundColor: theme.primary50,
      color: theme.primary500,
      fontSize: 12,
      padding: theme.spacing(1.5, 4),
      fontWeight: 500,
      marginRight: theme.spacing(4),
      borderRadius: "4px",
      display: "flex",
      alignItems: "center",
    },
    icon: {
      height: "14px",
      width: "14px",
      marginRight: theme.spacing(3),
    },
    label: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      fontSize: 12,
      maxWidth: 240,
    },
  }),
);

export const TriggerBadge = ({
  Icon,
  label,
}: {
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  label: string;
}) => {
  const classes = useStyles();
  const { observeElement, isOverflown } = useIsOverflown();

  return (
    <Tooltip text={label} disableHoverListener={!isOverflown} placement="top">
      <span className={classes.badge}>
        {Icon && <Icon className={classes.icon} />}
        <span className={classes.label} ref={observeElement}>
          {label}
        </span>
      </span>
    </Tooltip>
  );
};
